import { createSelector } from 'reselect';
import { STORE_KEY } from './constants';
import { Currency } from './models';
import type { State } from './reducers';

const stateSelector = (state: GlobalState) => state[STORE_KEY] as State;

export const currentCurrencySelector = createSelector(
    stateSelector,
    (state): Currency => state?.currentCurrency || Currency.Eur,
);
